import ApplicationSerializer from './application';

export default ApplicationSerializer.extend({
  get include() {
    return ['ticket-categories', 'ticket-category-emails'];
  },
});
